import { KameleoonError } from 'src/kameleoonError';
import { ConditionDataType } from './conditions/types';
import { NodeValueType, Operator } from './types';
import { ConditionFactoryInstance } from 'src/targeting/conditions/conditionFactoryInstance';

export interface INode {
  readonly value?: NodeValueType;
  readonly left?: INode;
  readonly right?: INode;
  readonly error?: KameleoonError;
}

export class Node implements INode {
  private nodeValue?: NodeValueType;
  private nodeError?: KameleoonError;
  private leftChild?: INode;
  private rightChild?: INode;
  private inverseResult: boolean = false;

  constructor(
    value: ConditionDataType | Operator,
    left?: INode,
    right?: INode,
  ) {
    if (this.isOperator(value)) {
      this.nodeValue = value;
    } else {
      const result = ConditionFactoryInstance.createCondition(value);
      this.inverseResult = !(value.isInclude ?? true);

      if (result.ok) {
        this.nodeValue = result.data;
      } else {
        this.nodeError = result.error;
      }
    }

    this.leftChild = left;
    this.rightChild = right;
  }

  get value(): NodeValueType | undefined {
    return this.nodeValue;
  }

  get error(): KameleoonError | undefined {
    return this.nodeError;
  }

  get left(): INode | undefined {
    return this.leftChild;
  }

  get right(): INode | undefined {
    return this.rightChild;
  }

  get inverse(): boolean {
    return this.inverseResult;
  }

  private isOperator(value: ConditionDataType | Operator): value is Operator {
    return value === Operator.And || value === Operator.Or;
  }
}
